export function createPageUrl(name) {
  return `/${name}`;
}

